<div class="body-wrapper" *ngIf="print.loaded" [ngClass]="Direction" style="padding-top: 0;">

    <header class="header">
        <div class="justify-between items-center" [innerHtml]="altHeader" *ngIf="altHeader && showHeader"></div>
        <div class="justify-between items-center" *ngIf="print.env && print.env['haslogo'] && !altHeader">
            <img style="width: 100%;" [src]="!print.env['haslogo'] ? '../../assets/images/logo.png' : '/api/logo'"
                alt="Logo">
        </div>
        <div class="justify-between items-center" style="margin-bottom: 5px;">
            <h1 class="header-title"
                style="max-width: 100%; font-size: 28px; white-space: normal; overflow-wrap: break-word;">
                {{ examTitle || print.exam.ExamType }}
                <span *ngIf="print.exam?.Draft">
                    ({{ 'general.DraftPrint' | translate }})
                </span>
            </h1>
        </div>
        <div class="header-details" style="margin-bottom: 3em;">
            <div style="display: inline-block; padding-left: 1em; padding-right: 1em; font-size: 12pt;">
                {{ 'general.date' | translate }}:&nbsp;<strong style="direction: ltr;">{{ print.exam.CreationTime | date:"dd.MM.yyyy" }}</strong>
            </div>
            <div style="display: inline-block; font-size: 12pt">
                {{ 'general.Printing_Date' | translate }}:&nbsp;
                <strong style="direction: ltr;">{{ now | date:"dd.MM.yyyy HH:mm" }}</strong>
            </div>
        </div>
    </header>

    <main class="main" [ngClass]="typeOfPrint">

        <!-- =============== patient details =============== -->
        <section class="section" *ngIf="print.Pat">
            <h4 class="text-20 text-gold">
                {{ (print.Pat.Sex ? (print.Pat.Sex == 'M' ? 'gastro.Patient.male' : 'gastro.Patient.female') : 'gastro.Patient.details') | translate }}
            </h4>
            <div style="width:100%">
                <table>
                    <tr>
                        <td>
                            <dt>{{ 'general.Patient.first_name' | translate }}</dt>
                            <dd>{{ print.Pat.First }}</dd>
                        </td>
                        <td>
                            <dt>{{ 'general.Patient.last_name' | translate }}</dt>
                            <dd>{{ print.Pat.Last }}</dd>
                        </td>
                        <td>
                            <dt>{{ 'general.Patient.id' | translate }}</dt>
                            <dd>{{ print.Pat.ID }}</dd>
                        </td>
                    </tr>
                    <tr>
                        <td *ngIf="print.Pat.Birth">
                            <dt>{{ 'general.Patient.birth_date' | translate }}</dt>
                            <dd>{{ print.Pat.Birth | date:"dd.MM.yyyy" }}</dd>
                        </td>
                        <td *ngIf="print.Pat.Birth">
                            <dt>{{ 'general.Patient.Age' | translate }}</dt>
                            <dd>{{ print.Pat.getAgeMo() }}</dd>
                        </td>
                        <td *ngIf="print.Pat.Sex">
                            <dt>מגדר</dt>
                            <dd>{{ print.Pat.Sex == 'M' ? 'גבר' : 'אישה' }}</dd>
                        </td>
                    </tr>
                </table>
            </div>
        </section>

        <!-- =============== the built exam =============== -->
        <ng-container *ngFor="let f of fields">
            <ng-container *ngIf="hasContent(f)">

                <!-- section header -->
                <h4 class="text-20 text-gold clinic-print-header" *ngIf="f.FieldType === 'header'">{{ f.Label }}</h4>

                <!-- plain text -->
                <section class="section" *ngIf="f.FieldType === 'text' || f.FieldType === 'picklist'">
                    <h4>{{ f.Label }}</h4>
                    <div style="white-space: pre-wrap;" dir="auto">{{ value(f) }}</div>
                </section>

                <!-- number + unit -->
                <section class="section" *ngIf="f.FieldType === 'number'">
                    <h4>{{ f.Label }}</h4>
                    <div dir="auto">{{ value(f) }}<span *ngIf="f.Config.unit">&nbsp;{{ f.Config.unit }}</span></div>
                </section>

                <!-- select -->
                <section class="section" *ngIf="f.FieldType === 'select'">
                    <h4>{{ f.Label }}</h4>
                    <div dir="auto">{{ value(f) }}</div>
                </section>

                <!-- yes / no + comment -->
                <section class="section" *ngIf="f.FieldType === 'yesno'">
                    <h4>{{ f.Label }}</h4>
                    <div dir="auto" *ngIf="toggleLabel(f)"><strong>{{ toggleLabel(f) }}</strong></div>
                    <div style="white-space: pre-wrap;" dir="auto" *ngIf="value(f, 'c')">{{ value(f, 'c') }}</div>
                </section>

                <!-- table -->
                <section class="section" *ngIf="f.FieldType === 'table'">
                    <h4>{{ f.Label }}</h4>
                    <div class="l-table-auto clinic-print-table">
                        <ng-container *ngFor="let r of f.Config.rows; let i = index">
                            <div class="l-row" *ngIf="rowValue(f, i) || rowValue(f, i, true)">
                                <div class="l-td-m" dir="auto"><strong>{{ r.label }}</strong></div>
                                <div class="l-td-m" dir="auto">{{ toggleLabel(f, 'r' + i) }}</div>
                                <div class="l-td-m" style="white-space: pre-wrap;" dir="auto"
                                    *ngIf="f.Config.comment">{{ rowValue(f, i, true) }}</div>
                            </div>
                        </ng-container>
                    </div>
                </section>

                <!-- the picked catalogue diagnoses (GUS-88) print above the summary -->
                <section class="section" *ngIf="f === firstPrintedSummary() && print.hasExamDiagnoses()">
                    <h4>{{ 'summary.diagnosis.title' | translate }}</h4>
                    <ng-container *ngIf="print.examDiagnoses.length">
                        <h4>{{ 'examDiagnoses.main' | translate }}</h4>
                        <div style="white-space: pre-wrap;" dir="auto">{{ print.diagnosesText() }}</div>
                    </ng-container>
                    <ng-container *ngIf="print.secondaryDiagnoses.length">
                        <h4>{{ 'examDiagnoses.secondary' | translate }}</h4>
                        <div style="white-space: pre-wrap;" dir="auto">{{ print.secondaryDiagnosesText() }}</div>
                    </ng-container>
                    <ng-container *ngIf="print.examDiagnosisNotes">
                        <h4>{{'gastro.abdomen.Findings' | translate}}</h4>
                        <div style="white-space: pre-wrap;" dir="auto">{{ print.examDiagnosisNotes }}</div>
                    </ng-container>
                </section>

                <!-- summary (rich text) -->
                <section class="section" *ngIf="f.FieldType === 'summary'">
                    <h4>{{ f.Label }}</h4>
                    <div dir="auto" [innerHtml]="value(f)"></div>
                </section>

            </ng-container>
        </ng-container>

        <section class="section" *ngIf="dataLoaded && !anyContent()">
            <div>לא הוזן תוכן בבדיקה.</div>
        </section>

        <!-- =============== Exam Diagnoses (Start) =============== -->
        <!-- no summary field in this template, so the diagnoses close the exam -->
        <section class="section" *ngIf="print.hasExamDiagnoses() && !firstPrintedSummary()">
            <h4>{{ 'summary.diagnosis.title' | translate }}</h4>
            <ng-container *ngIf="print.examDiagnoses.length">
                <h4>{{ 'examDiagnoses.main' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.diagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.secondaryDiagnoses.length">
                <h4>{{ 'examDiagnoses.secondary' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.secondaryDiagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.examDiagnosisNotes">
                <h4>{{'gastro.abdomen.Findings' | translate}}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.examDiagnosisNotes }}</div>
            </ng-container>
        </section>
        <!-- =============== Exam Diagnoses (End) =============== -->
        <!-- =============== Exam Signature (Start) =============== -->
        <ng-container *ngIf="!print.exam.Draft && print.exam.SignedBy && print.exam.SignedDate">
            <section class="section">
                <div style="margin-top: 1em">
                    <strong>{{ 'cardio.summary.signExam' | translate }}</strong>
                    {{ print.exam.SignedBy }}
                    {{ 'cardio.summary.at' | translate }}
                    {{ print.exam.SignedDate | date:"dd.MM.yyyy HH:mm" }}
                    <ng-container *ngIf="print.exam.license">
                        <strong>מ.ר.</strong> {{ print.exam.license }}
                    </ng-container>
                    <ng-container *ngIf="print.exam.ExpertNum">
                        <strong>מ.ר.מ.</strong> {{ print.exam.ExpertNum }}
                    </ng-container>
                </div>
            </section>
        </ng-container>
        <!-- =============== Exam Signature (End) =============== -->

        <div *ngIf="hasImages && print.images.length > 0" class="signatures" [ngClass]="'perpage' + imPerPage">
            <ng-container *ngFor="let image of print.images">
                <div style="width: fit-content; display: inline-flex; flex-direction: column;">
                    <img style="padding: 0.5em;" [src]="'/api/getmedia/' + image.src + '/n'">
                    <p *ngIf="image.text" class="section" style="width: 95%; margin-inline-start: 0.5em;"
                        [ngClass]="imPerPage == 2 ? 'w100' : 'w95'">{{ image.text }}</p>
                </div>
            </ng-container>
        </div>

        <span class="comment finished" *ngIf="loaded"></span>
    </main>
</div>
